// extracted by mini-css-extract-plugin
export default {"fileDrop":"FileDrop_fileDrop__n-A6T"};